import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import SelfDiagnosis from "@/pages/self-diagnosis/page";
import CourseComparison from "@/pages/course-comparison/page";
import Palette from "@/pages/palette/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />, // Photography template is full-screen, no Layout
  },
  {
    element: <Layout />,
    children: [
      {
        path: "/자가진단",
        element: <SelfDiagnosis />,
      },
      {
        path: "/self-diagnosis",
        element: <SelfDiagnosis />,
      },
      {
        path: "/과정비교",
        element: <CourseComparison />,
      },
      {
        path: "/course-comparison",
        element: <CourseComparison />,
      },
      {
        path: "/팔레트",
        element: <Palette />,
      },
      {
        path: "/palette",
        element: <Palette />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
